var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-autocomplete',{class:_vm.inputClass,attrs:{"options":{
    fields: ['geometry', 'formatted_address', 'address_components'],
    componentRestrictions: { country: _vm.country },
  },"placeholder":_vm.placeholder},on:{"place_changed":_vm.action}})
}
var staticRenderFns = []

export { render, staticRenderFns }